import React from "react";
import { Button } from "@chakra-ui/react";
import { useMutation } from "@apollo/client";
import { CHANGE_FAILED_EMAIL_STATUS_TO_REVIEW } from "@/api/mutations";
import { FAILED_EMAILS } from "@/api/queries";
import { toaster } from "@/components/ui/toaster";

type ListPagination = { page: number; limit: number };

const MoveToManualReviewButton = ({
  emailId,
  listPagination,
}: {
  emailId: string | number;

  listPagination?: ListPagination;
}) => {
  const [changeStatus, { loading }] = useMutation(
    CHANGE_FAILED_EMAIL_STATUS_TO_REVIEW,
    {
      refetchQueries: listPagination
        ? [
            {
              query: FAILED_EMAILS,
              variables: {
                page: listPagination.page,
                limit: listPagination.limit,
              },
            },
          ]
        : [FAILED_EMAILS],
      awaitRefetchQueries: true,
    },
  );

  const handleClick = async () => {
    try {
      const result = await changeStatus({
        variables: { emailId: String(emailId) },
      });
      const data = result?.data?.changeFailedEmailStatusToReview;
      if (data?.__typename === "ErrorType") {
        toaster.create({
          title: "Could not move to manual review",
          description: data.message ?? "Something went wrong.",
          type: "error",
          closable: true,
        });
        return;
      }
      if (data?.__typename === "SuccessType") {
        toaster.create({
          title: "Updated",
          description:
            data.message ?? "Email status successfully updated.",
          type: "success",
          closable: true,
        });
      }
    } catch (err: unknown) {
      const message =
        err instanceof Error ? err.message : "Something went wrong.";
      toaster.create({
        title: "Could not move to manual review",
        description: message,
        type: "error",
        closable: true,
      });
    }
  };

  return (
    <Button
      colorPalette="brand"
      size="sm"
      loading={loading}
      onClick={(e) => {
        e.stopPropagation();
        void handleClick();
      }}
    >
      Move to Manual Review
    </Button>
  );
};

export default MoveToManualReviewButton;
